import { IsNotEmpty, IsUUID, IsArray, IsString } from 'class-validator';

import { FormAttributesRequest } from '../../types';
import { NOT_EMPTY_OPTIONS } from '../../constants';

export class CompetencyProfileDto {
  @IsUUID()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  eventId: string;

  @IsUUID()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  nodeId: string;

  @IsString({ each: true })
  @IsArray()
  competencies: string[];

  attributes?: FormAttributesRequest;
}
